// extracted by mini-css-extract-plugin
export var projectCards = "ProjectCards-module--projectCards--f71b6";